import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import { useScanSelfServiceAutosuggestionsContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceAutosuggestionsContext';
import { useScanSelfServiceContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceContext';

export const OVERLAY_STATUS_PRODUCT_OPEN = 'product-open';
export const OVERLAY_STATUS_SEARCH_INPUT_OPEN = 'search-input-open';
export const OVERLAY_STATUS_CLOSE = 'close';

const ScanSelfServiceOverlayContext = createContext(null);
const ScanSelfServiceOverlayProvider = ({ children }) => {
  const prevHasProductRef = useRef(false);
  const { hasProduct } = useScanSelfServiceContext();
  const { isOpen } = useScanSelfServiceAutosuggestionsContext();
  const [overlayStatus, setOverlayStatus] = useState(OVERLAY_STATUS_CLOSE);

  const handleOpen = (status) => {
    setOverlayStatus(status);
  };
  const handleClose = () => {
    if (!hasProduct && !isOpen) {
      setOverlayStatus(OVERLAY_STATUS_CLOSE);
    }
  };

  useEffect(() => {
    if (prevHasProductRef.current && !hasProduct) {
      setOverlayStatus(OVERLAY_STATUS_CLOSE);
    }
    if (!prevHasProductRef.current && hasProduct) {
      setOverlayStatus(OVERLAY_STATUS_PRODUCT_OPEN);
    }
    prevHasProductRef.current = hasProduct;
  }, [hasProduct]);

  return (
    <ScanSelfServiceOverlayContext.Provider
      value={{
        overlayStatus,
        openOverlay: handleOpen,
        closeOverlay: handleClose,
      }}
    >
      {children}
    </ScanSelfServiceOverlayContext.Provider>
  );
};

ScanSelfServiceOverlayProvider.defaultProps = {
  ...ChildrenDefaultProps,
};

ScanSelfServiceOverlayProvider.propTypes = {
  ...ChildrenPropTypes,
};

export const useScanSelfServiceOverlayContext = () =>
  useContext(ScanSelfServiceOverlayContext);

export default ScanSelfServiceOverlayProvider;
